/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as SelectBranchRouteImport } from './routes/select-branch'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppBranchesRouteImport } from './routes/_app/branches'
import { Route as AppEmployeesRouteImport } from './routes/_app/employees'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectBranchRoute = SelectBranchRouteImport.update({
  id: '/select-branch',
  path: '/select-branch',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppBranchesRoute = AppBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesRoute = AppEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/select-branch': typeof SelectBranchRoute
  '/set-password': typeof SetPasswordRoute
  '/branches': typeof AppBranchesRoute
  '/employees': typeof AppEmployeesRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/select-branch': typeof SelectBranchRoute
  '/set-password': typeof SetPasswordRoute
  '/branches': typeof AppBranchesRoute
  '/employees': typeof AppEmployeesRoute
  '/': typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/select-branch': typeof SelectBranchRoute
  '/set-password': typeof SetPasswordRoute
  '/_app/branches': typeof AppBranchesRoute
  '/_app/employees': typeof AppEmployeesRoute
  '/_app/': typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/select-branch'
    | '/set-password'
    | '/branches'
    | '/employees'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/select-branch'
    | '/set-password'
    | '/branches'
    | '/employees'
    | '/'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/select-branch'
    | '/set-password'
    | '/_app/branches'
    | '/_app/employees'
    | '/_app/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  SelectBranchRoute: typeof SelectBranchRoute
  SetPasswordRoute: typeof SetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-branch': {
      id: '/select-branch'
      path: '/select-branch'
      fullPath: '/select-branch'
      preLoaderRoute: typeof SelectBranchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/branches': {
      id: '/_app/branches'
      path: '/branches'
      fullPath: '/branches'
      preLoaderRoute: typeof AppBranchesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees': {
      id: '/_app/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AppEmployeesRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppBranchesRoute: typeof AppBranchesRoute
  AppEmployeesRoute: typeof AppEmployeesRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBranchesRoute: AppBranchesRoute,
  AppEmployeesRoute: AppEmployeesRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  SelectBranchRoute: SelectBranchRoute,
  SetPasswordRoute: SetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
